import React from 'react';
import quoteService from '../../../services/quote.service';
import { useQuoteFieldDefinitions } from '../../../hooks/useQuoteFieldDefinitions';
import CustomFilterDialogBase, { type CustomFilterDialogProps } from './CustomFilterDialogBase';

/*
 * Quotes Custom Filter — the quotes binding of the shared condition builder
 * (CustomFilterDialogBase): fields from the DB-driven scope='quotes' registry
 * (GET /field-definitions?scope=quotes), saved filters from
 * /quotes/custom-filters. Everything else (rows, apply/clear, save/load, the
 * legacy-blob rules) lives in the base and is shared with the templates variant.
 *
 * The filter helpers are re-exported here because QuotesPage / SearchResults /
 * CustomOrderFilterForm import them from this module.
 */
export { buildFilterJson, parseFilterJson, summarizeFilter } from './CustomFilterDialogBase';

const CustomFilterDialog: React.FC<CustomFilterDialogProps> = (props) => {
  const { fieldDefinitions, loading } = useQuoteFieldDefinitions(props.open);
  return (
    <CustomFilterDialogBase
      {...props}
      fieldDefinitions={fieldDefinitions}
      loadingFields={loading}
      listFilters={() => quoteService.listCustomFilters()}
      saveFilter={(name, filter) => quoteService.saveCustomFilter(name, filter)}
    />
  );
};

export default CustomFilterDialog;
